import axiosInstance from './axiosInstance';
import config from '../config';
import { PurchaseInvoice, CreatePurchaseInvoiceDto, UpdatePurchaseInvoiceDto } from '../types/purchaseInvoices.types';

const API_URL = `${config.API_BASE_URL}/PurchaseInvoices`;

export const purchaseInvoicesService = {
  getAll: async (
    status?: string,
    supplierId?: number,
    fromDate?: string,
    toDate?: string,
    warehouseId?: number
  ): Promise<PurchaseInvoice[]> => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (supplierId) params.append('supplierId', supplierId.toString());
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);
    if (warehouseId) params.append('warehouseId', warehouseId.toString());
    const url = params.toString() ? `${API_URL}?${params.toString()}` : API_URL;
    const response = await axiosInstance.get<PurchaseInvoice[]>(url);
    return response.data;
  },

  getById: async (id: number): Promise<PurchaseInvoice> => {
    const response = await axiosInstance.get<PurchaseInvoice>(`${API_URL}/${id}`);
    return response.data;
  },

  create: async (purchaseInvoice: CreatePurchaseInvoiceDto): Promise<PurchaseInvoice> => {
    const response = await axiosInstance.post<PurchaseInvoice>(API_URL, purchaseInvoice);
    return response.data;
  },

  update: async (id: number, purchaseInvoice: UpdatePurchaseInvoiceDto): Promise<PurchaseInvoice> => {
    const response = await axiosInstance.put<PurchaseInvoice>(`${API_URL}/${id}`, purchaseInvoice);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },

  postInvoice: async (id: number): Promise<PurchaseInvoice> => {
    const response = await axiosInstance.post<PurchaseInvoice>(`${API_URL}/${id}/post`);
    return response.data;
  },

  unpostInvoice: async (id: number): Promise<PurchaseInvoice> => {
    const response = await axiosInstance.post<PurchaseInvoice>(`${API_URL}/${id}/unpost`);
    return response.data;
  },

  generateInvoiceNumber: async (): Promise<string> => {
    const response = await axiosInstance.get<string>(`${API_URL}/generate-invoice-number`);
    return response.data;
  },
};